import {
	ReceptionFolderFiles,
	ConstructionSiteDocumentType,
	HumanProcessingStatus,
} from "@dune/types";
import { privateAxios } from "../axios";
import { useQuery } from "@tanstack/react-query";
import { constructionSiteReceptionQueryKeys } from "../query-keys/constructionSiteReception.query-keys";

export interface ReceptionOperationFile {
	type: ConstructionSiteDocumentType | null;
	file: {
		id: string;
		name: string;
		key: string;
		size: number;
		createdAt: Date;
		humanProcessingStatus: HumanProcessingStatus;
	};
}

export interface ReceptionOperationFiles {
	filesOnConstructionSiteReception: ReceptionOperationFile[];
}

export const getConstructionSiteReceptionFolder = async (
	constructionSiteId: number,
) => {
	const { data } = await privateAxios.get<ReceptionFolderFiles>(
		`/construction-sites-reception/${constructionSiteId}/folder`,
	);
	return data;
};

export const useGetConstructionSiteReceptionFolder = (
	constructionSiteId: number,
) => {
	return useQuery({
		queryKey: constructionSiteReceptionQueryKeys.folder(constructionSiteId),
		queryFn: () => getConstructionSiteReceptionFolder(constructionSiteId),
	});
};

export const getConstructionSiteReceptionOperationFiles = async (
	constructionSiteId: number,
) => {
	const { data } = await privateAxios.get<ReceptionOperationFiles>(
		`/construction-sites-reception/${constructionSiteId}/operation-files`,
	);
	return data;
};

export const useGetConstructionSiteReceptionOperationFiles = (
	constructionSiteId: number,
) => {
	return useQuery({
		queryKey: [
			...constructionSiteReceptionQueryKeys.detail(constructionSiteId),
			"operation-files",
		],
		queryFn: () =>
			getConstructionSiteReceptionOperationFiles(constructionSiteId),
		enabled: !!constructionSiteId,
	});
};
